import React from 'react'

import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import { FormattedMessage } from 'react-intl'
import { getMileageUnit } from 'core/utils/cultures/unit'
import styled from 'styled-components'
import { font } from 'assets/themes/theme-default'

import svg from 'assets/svg'
import { Row, Col } from 'core/components/ui'

import { ContentWrapper, Title, DataWrapper, Badge, CustomTag, Icon } from './styled'

const TitleSpan = styled.span`
  font-weight: ${font.weight.base};
`

export const DistributorCard = ({ ...props }) => {
  const { pointOfSales, count, handleChangePointOfSales, selectedPointOfSale } = props
  return (
    <>
      <ContentWrapper
        className={pointOfSales.id === selectedPointOfSale && 'selected'}
        count={count}
        onClick={e => {
          e.preventDefault()
          handleChangePointOfSales(pointOfSales)
        }}
      >
        <Row>
          <Col xs={16} sm={17}>
            <Title>{pointOfSales.name}</Title>
          </Col>
          <Col xs={8} sm={7} align="right">
            {count === 0 && pointOfSales.distance && (
              <CustomTag>
                <FormattedMessage id="closest" />
              </CustomTag>
            )}
            {isMobile && pointOfSales.distance && (
              <TitleSpan>
                <FormattedMessage
                  id="distance-away"
                  values={{
                    distance: pointOfSales.distance,
                    distance_unit: getMileageUnit()
                  }}
                />
              </TitleSpan>
            )}
          </Col>
        </Row>

        <Row>
          <Col sm={19}>
            {(pointOfSales.address1 || pointOfSales.address2) && (
              <DataWrapper>{[pointOfSales.address1, pointOfSales.address2].join(', ')}</DataWrapper>
            )}
            {(pointOfSales.complementaryAddress1 || pointOfSales.complementaryAddress2) && (
              <DataWrapper>
                {[pointOfSales.complementaryAddress1, pointOfSales.complementaryAddress2].join(
                  ', '
                )}
              </DataWrapper>
            )}
            {(pointOfSales.city || pointOfSales.zipCode) && (
              <DataWrapper>
                {pointOfSales.zipCode} {pointOfSales.city}
              </DataWrapper>
            )}
            {pointOfSales.state && <DataWrapper>{pointOfSales.state}</DataWrapper>}
          </Col>
          {!isMobile && pointOfSales.distance && (
            <Col sm={5} align="right">
              <TitleSpan>
                <FormattedMessage
                  id="distance-away"
                  values={{
                    distance: pointOfSales.distance,
                    distance_unit: getMileageUnit()
                  }}
                />
              </TitleSpan>
            </Col>
          )}
        </Row>
        {(pointOfSales.phone || pointOfSales.email) && (
          <>
            <TitleSpan style={{ display: 'block' }}>
              <FormattedMessage id="contact_us" />
            </TitleSpan>
            {pointOfSales.phone && (
              <div>
                <Icon svg={svg.phone} />
                <span>
                  {pointOfSales.phonePrefixCode} {pointOfSales.phone}
                </span>
              </div>
            )}
            {pointOfSales.email && (
              <div>
                <Icon svg={svg.at} />
                {pointOfSales.email}
              </div>
            )}
          </>
        )}
        <Badge>
          <span>{count + 1}</span>
        </Badge>
      </ContentWrapper>
    </>
  )
}

DistributorCard.propTypes = {
  pointOfSales: PropTypes.shape(),
  count: PropTypes.string,
  handleChangePointOfSales: PropTypes.func.isRequired,
  selectedPointOfSale: PropTypes.number
}
export default DistributorCard
